import styled from "styled-components";
import {useMomentCountdown} from "hooks/useMomentCountdown"
import {defaultThemeColors, fonts} from "ui/theme";

require("moment-timezone")

export const Countdown = ({targetTime, timezone}) => {
    const {days, hours, minutes, seconds} =
        useMomentCountdown(targetTime, timezone)

    if (Number(days) + Number(hours) + Number(minutes) + Number(seconds) <= 0) {
        return null
    }

    return <CountDownContainer>{`${hours}h ${minutes}m ${seconds}s to accept`}</CountDownContainer>
}


const CountDownContainer = styled.div`
    font-weight: 600;
    font-size: ${fonts.sizes.extraSmall};
    color: ${defaultThemeColors.blue};
`